import { render, staticRenderFns } from "./start-game.vue?vue&type=template&id=7df0de04&scoped=true&"
import script from "./start-game.vue?vue&type=script&lang=js&"
export * from "./start-game.vue?vue&type=script&lang=js&"
import style0 from "./start-game.vue?vue&type=style&index=0&id=7df0de04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df0de04",
  null
  
)

export default component.exports